module.exports = __webpack_public_path__ + "img/boton-encuesta-200x200.d3e4c32b.png";